import { Component, Vue } from "vue-property-decorator";
import { BASE_API_URL } from "../../utils/Constants";
import MediumType, { MediumTypology } from "@/models/MediumType";

export const GET_MEDIUM_TYPES = "get_medium_types";
export const GET_ADMIN_MEDIUM_TYPES = "get_admin_medium_types";
export const SAVE_ADMIN_MEDIUM_TYPES = "save_admin_medium_types";
export const DELETE_ADMIN_MEDIUM_TYPES = "delete_admin_medium_types";

import qs from "qs";

@Component
export default class MediumTypeMixin extends Vue {
  readonly mediumTypesPath = BASE_API_URL + "medium_types";
  readonly adminMediumTypesPath = BASE_API_URL + "admin/medium_types";

  async getRawMediumTypes(): Promise<MediumType[]> {
    return await this.$httpGet(this.mediumTypesPath, GET_MEDIUM_TYPES);
  }

  async getRawQueriedMediumTypes(filter: any): Promise<MediumType[]> {
    const params = qs.stringify(filter);
    const path = `${this.adminMediumTypesPath}?${params}`;
    return await this.$httpGet(path, GET_MEDIUM_TYPES);
  }

  async getMediumTypes(): Promise<MediumTypology[]> {
    const results: MediumTypology[] = [];
    const mediumTypes = await this.$httpGet(
      this.mediumTypesPath,
      GET_MEDIUM_TYPES
    );
    mediumTypes.map((mediumType: MediumType) => {
      const mediumTypology: MediumTypology = {
        name: mediumType.name,
        id: mediumType.id,
        icon: `media-${mediumType.typology}`,
        reach: mediumType.reach,
        typology: mediumType.typology,
        exportGranularity: mediumType.exportGranularity,
        unitOfMeasurement: mediumType.unitOfMeasurement,
        croppedLogo: mediumType.croppedLogo,
        position: mediumType.position,
        budgetDescription: mediumType.budgetDescription,
        showInSlides: mediumType.showInSlides,
        slideImageUrl: mediumType.slideImageUrl,
      };
      results.push(mediumTypology);
    });

    return results;
  }

  async getAdminMediumTypes(page: number): Promise<MediumType[]> {
    return await this.$httpGet(
      this.adminMediumTypesPath + `?page=${page}`,
      GET_ADMIN_MEDIUM_TYPES
    );
  }

  async postAdminMediumType(
    payload: MediumType,
    logo: File | null,
    slideImage: File | null
  ): Promise<MediumType> {
    const formData = new FormData();
    formData.append("params[name]", payload.name);
    formData.append("params[reach]", payload.reach);
    formData.append("params[unit_of_measurement]", payload.unitOfMeasurement);
    formData.append("params[export_granularity]", payload.exportGranularity);
    formData.append("params[typology]", payload.typology);
    formData.append("params[position]", payload.position.toString());
    formData.append("params[budget_description]", payload.budgetDescription);
    formData.append("params[show_in_slides]", payload.showInSlides.toString());
    if (logo) {
      formData.append("params[logo]", logo);
    }
    if (slideImage) {
      formData.append("params[slide_image]", slideImage);
    }
    return await this.$httpPost(
      this.adminMediumTypesPath,
      SAVE_ADMIN_MEDIUM_TYPES,
      formData
    );
  }

  async putAdminMediumType(
    payload: MediumType,
    logo: File | null,
    slideImage: File | null
  ): Promise<MediumType> {
    const formData = new FormData();
    formData.append("params[name]", payload.name);
    formData.append("params[reach]", payload.reach);
    formData.append("params[unit_of_measurement]", payload.unitOfMeasurement);
    formData.append("params[export_granularity]", payload.exportGranularity);
    formData.append("params[typology]", payload.typology);
    formData.append("params[position]", payload.position.toString());
    formData.append("params[budget_description]", payload.budgetDescription);
    formData.append("params[show_in_slides]", payload.showInSlides.toString());
    if (logo) {
      formData.append("params[logo]", logo);
    }
    if (slideImage) {
      formData.append("params[slide_image]", slideImage);
    }
    return await this.$httpPut(
      this.adminMediumTypesPath + `/${payload.id}`,
      SAVE_ADMIN_MEDIUM_TYPES,
      formData
    );
  }

  async deleteAdminMediumType(payload: string): Promise<void> {
    return await this.$httpDelete(
      this.adminMediumTypesPath + `/${payload}`,
      DELETE_ADMIN_MEDIUM_TYPES,
      { id: payload }
    );
  }
}
